import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit {
  model = new ContactFormModel('', '', '');
  submited = false;
  isCaptchaSolved = false;

  constructor(private http: HttpClient) {}

  ngOnInit() {}

  onSubmit() {
    this.submited = true;
    this.http
      .post(
        'https://codesender.azurewebsites.net/api/SendContactFormMail?code=afJ6IIon4Df1ccRmiLwZ6oP9Hk3bhXBgvRbWaHLaXdw7AcVSvXdbAw==',
        JSON.stringify(this.model)
      )
      .subscribe(x => {
        this.submited = true;
        console.log(x);
      });
  }

  captchaResolved($event) {
    this.isCaptchaSolved = true;
  }
}

class ContactFormModel {
  constructor(public name: string, public email: string, public body: string) {}
}



// WEBPACK FOOTER //
// C:/Users/dtarc/source/repos/CODESENDER/web/src/app/contact-form/contact-form.component.ts